var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-form-item",
    { attrs: { label: _vm.name, prop: _vm.name, rules: _vm.rules } },
    [
      _c(
        "el-tooltip",
        {
          attrs: {
            content: "点击上传图片",
            placement: "top",
            disabled: _vm.disabled,
          },
        },
        [
          _c("el-input", {
            staticStyle: { width: "calc(100% - 30px)" },
            attrs: { disabled: _vm.disabled, placeholder: "点击上传图片" },
            on: {
              focus: function ($event) {
                _vm.dialogVisible = true
              },
            },
            model: {
              value: _vm.val,
              callback: function ($$v) {
                _vm.val = $$v
              },
              expression: "val",
            },
          }),
        ],
        1
      ),
      _c("i", { staticClass: "el-icon-upload" }),
      _c(
        "el-dialog",
        {
          attrs: { width: "500px", visible: _vm.dialogVisible },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "image-upload-container" },
            [
              _c("el-upload", {
                attrs: {
                  action: "#",
                  data: { token: _vm.token },
                  accept: _vm.accept,
                  "list-type": "picture-card",
                  "file-list": _vm.previewList,
                  limit: 1,
                  "http-request": _vm.uploadImage,
                  "on-remove": _vm.handleRemove,
                  "on-exceed": _vm.handleExceed,
                },
                scopedSlots: _vm._u([
                  {
                    key: "trigger",
                    fn: function () {
                      return [
                        _c(
                          "div",
                          {
                            staticClass:
                              "h-full trigger-con flex flex-col align-center justify-center",
                          },
                          [
                            _c("img", {
                              staticClass: "plus-icon",
                              attrs: {
                                src: require("@/assets/list/plus.png"),
                                alt: "",
                              },
                            }),
                            _c("span", { staticClass: "icon-label" }, [
                              _vm._v("上传"),
                            ]),
                          ]
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
              _c("span", { staticClass: "tips" }, [
                _vm._v(" " + _vm._s(_vm.tips) + " "),
              ]),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }